import React from "react";
import { Link } from "react-router-dom";
import CVFile from "../../../assets/files/richard-cv.pdf";
import Logo from "../../../assets/images/Hero2.png";

export const HeroSection = () => {
  const handleDownloadCV = () => {
    const link = document.createElement("a");
    link.href = CVFile;
    link.download = "Richard_Tambong_CV.pdf";
    link.target = "_blank";
    link.click();
  };

  return (
    <>
      <section className="pt-10 overflow-hidden md:pt-0 sm:pt-16 2xl:py-32 xs:px-1">
        <div className="px-4 mx-auto sm:px-6 lg:px-8 max-w-7xl">
          <div className="grid items-center grid-cols-1 md:grid-cols-2">
            <div>
              <p className="leading-relaxed text-gray-300">
                Hi There, I am
              </p>

              <h1 className="text-white my-2 text-3xl font-extrabold leading-9 tracking-tight sm:text-4xl sm:leading-10 md:text-5xl md:leading-normal">
                Richard Tambong
              </h1>

              <p className="max-w-lg text-xl leading-relaxed text-gray-300">
                Full Stack Developer with a passion for creating web
                applications with expertise in both front-end and back-end
                technologies.
              </p>

              <p className="my-4 text-xl text-gray-600 md:my-8">
                <span className="relative inline-block">
                  <Link to="/explore">
                    <button className="inline-flex text-white hover:text-black bg-emerald-800 outline outline-white py-2 px-6 focus:outline-none hover:bg-emerald-600 rounded text-lg">
                      Explore
                    </button>
                  </Link>

                  <button
                    onClick={handleDownloadCV}
                    className="ml-4 inline-flex text-white hover:text-black bg-transparent outline outline-white border-0 py-2 px-6 rounded text-lg"
                  >
                    Resume
                  </button>
                </span>
              </p>
            </div>

            <div className="hidden md:inline-block relative w-45 h-45 xl:max-w-lg xl:mx-auto md:scale-75">

              <img className="rounded-full" src={Logo} alt="prtflimg" />
            </div>
          </div>
        </div>
      </section>
    </>
  );
};
